<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Paciente</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="file-upload-field">
            <label>Foto</label>
            <file-upload
              :defaultImage="srcImagen"
              ref="fileUpload"
            ></file-upload>
          </div>
          <span
            v-if="errores.imagen"
            class="helper-text text-danger"
            slot="helper"
          >
            <strong>{{ errores.imagen[0] }}</strong>
          </span>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="nombre"
            placeholder="Nombres"
            v-model="form.nombre"
          >
            <span>Nombre</span>
            <span
              v-if="errores.nombre"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.nombre[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="apellido"
            placeholder="Apellidos"
            v-model="form.apellido"
          >
            <span>Apellidos</span>
            <span
              v-if="errores.apellido"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.apellido[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            type="password"
            id="clave_acceso"
            placeholder="Clave de acceso"
            v-model="form.clave_acceso"
          >
            <span>Contraseña</span>
            <span
              v-if="errores.clave_acceso"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.clave_acceso[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            type="password"
            id="clave_acceso_confirmation"
            placeholder="Confirmar clave..."
            v-model="form.clave_acceso_confirmation"
          >
            <span>Confirmación de contraseña</span>
            <span
              v-if="errores.clave_acceso_confirmation"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.clave_acceso_confirmation[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <div class="datepicker-field">
            <date-picker
              type="date"
              id="fecha_nacimiento"
              v-model="form.fecha_nacimiento"
            ></date-picker>
            <label>Fecha de nacimiento</label>
            <span
              v-if="errores.fecha_nacimiento"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.fecha_nacimiento[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field readonly id="edad" placeholder="Edad" :value="edad">
            <span>Edad</span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            v-mask="'#############'"
            id="cedula"
            placeholder="Número de identificación"
            v-model="form.identificacion"
          >
            <span>Cédula/Pasaporte</span>
            <span
              v-if="errores.identificacion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.identificacion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="direccion"
            placeholder="Escriba una dirección..."
            v-model="form.direccion"
          >
            <span>Dirección</span>
            <span
              v-if="errores.direccion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.direccion[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="telefono"
            placeholder="Escriba un teléfono..."
            v-model="form.telefono"
          >
            <span>Teléfono</span>
            <span
              v-if="errores.telefono"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.telefono[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="celular"
            placeholder="Escriba un celular..."
            v-model="form.celular"
          >
            <span>Celular</span>
            <span
              v-if="errores.celular"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.celular[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="email"
            placeholder="Escriba una dirección de correo electrónico..."
            v-model="form.email"
          >
            <span>Correo electrónico</span>
            <span
              v-if="errores.email"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.email[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <label for="masculino">
          <input
            type="radio"
            name="sexo"
            id="masculino"
            v-model="form.sexo"
            value="M"
          />
          <span>Masculino</span>
        </label>
        <label for="femenino">
          <input
            type="radio"
            name="sexo"
            id="femenino"
            v-model="form.sexo"
            value="F"
          />
          <span>Femenino</span>
        </label>
      </div>
      <div class="col-xs-12">
        <h5>Datos de filiación</h5>
      </div>
      <div class="col-xs-12 col-md-4">
         <label for="hipertension_arterial">
            <input v-model="form.hipertension_arterial" type="checkbox" name="hipertension_arterial" id="hipertension_arterial"><span>Hipertensión arterial</span>
         </label>
      </div>
      <div class="col-xs-12 col-md-4">
         <label for="diabetes_mellitus">
            <input v-model="form.diabetes_mellitus" type="checkbox" name="diabetes_mellitus" id="diabetes_mellitus"><span>Diabetes mellitus</span>
         </label>
      </div>
      <div class="col-xs-12 col-md-4">
         <label for="cirrosis_hepatica">
            <input v-model="form.cirrosis_hepatica" type="checkbox" name="cirrosis_hepatica" id="cirrosis_hepatica"><span>Cirrosis hepática</span>
         </label>
      </div>
      <div class="col-xs-12 col-md-4">
         <label for="insuficiencia_renal">
            <input v-model="form.insuficiencia_renal" type="checkbox" name="insuficiencia_renal" id="insuficiencia_renal"><span>Insuficiencia renal</span>
         </label>
      </div>
      <div class="col-xs-12 col-md-4">
         <label for="hipotiroidismo">
            <input v-model="form.hipotiroidismo" type="checkbox" name="hipotiroidismo" id="hipotiroidismo"><span>Hipotiroidismo</span>
         </label>
      </div>
      <div class="col-xs-12 col-md-4">
         <label for="insuficiencia_cardiaca">
            <input v-model="form.insuficiencia_cardiaca" type="checkbox" name="insuficiencia_cardiaca" id="insuficiencia_cardiaca"><span>Insuficiencia cardíaca</span>
         </label>
      </div>
      <div class="col-xs-12 col-md-4">
         <label for="otras">
            <input v-model="form.otras" type="checkbox" name="otras" id="otras"><span>Otras</span>
         </label>
      </div>
      <div class="col-xs-12"></div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="email"
            placeholder="Escriba el tratamiento..."
            v-model="form.tratamiento"
          >
            <span>Tratamientos</span>
            <span
              v-if="errores.tratamiento"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.tratamiento[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="email"
            placeholder="Escriba sus alergias..."
            v-model="form.alergias"
          >
            <span>Alergias</span>
            <span
              v-if="errores.alergias"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.alergias[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="guardar" class="btn-success" type="button">
        <i class="fa fa-save"></i>
        <span>Guardar</span>
      </button>
      <button
        @click="$emit('cancelar')"
        class="btn-danger btn--text"
        type="button"
      >
        <i class="fa fa-ban"></i>
        <span>Cancelar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  computed: {
    edad: function() {
      if (
        this.form.fecha_nacimiento != null &&
        this.form.fecha_nacimiento.length === 10
      ) {
        let date = new Date(this.form.fecha_nacimiento);
        if (date != "Invalid Date")
          return moment(new Date()).diff(date, "years");
      }
      return "";
    }
  },
  data: function() {
    return {
      srcImagen : '',
      form: JSON.parse(JSON.stringify(this.value)),
      errores: {},
      decimal5: decimal5
    };
  },
  methods: {
    cargarImagen: function() {
      this.form.imagen = this.$refs.fileUpload.recuperarImagen();
    },
    guardar: function() {
      let that = this;
      this.cargarImagen();
      let urlRequest = url + "/pacientes/"+ this.form.id;
      axios
        .post(urlRequest, this.form)
        .then(function(response) {
          swal("El paciente fue almacenado.", "Realizado", "success");
          that.$emit("saved", response.data);
        })
        .catch(function(error) {
          if (error && error.response) {
            let response = error.response;
            let status = response.status;
            switch (status) {
              case 422:
                that.errores = response.data.errors;
                swal("Hay errores en el formulario.", "Aviso", "warning");
                return;
            }
          }
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    cancelar: function() {
      this.$emit("cancelar");
    }
  },
  mounted : function () {
    if (this.form.imagen !== null && this.form.imagen !== "")
      this.srcImagen = this.form.imagen;
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/pacientes/Paciente.vue